import React from "react";
import HeroBgAnimation from "../HeroBgAnimation";
import {
  HeroContainer,
  HeroBg,
  HeroLeftContainer,
  Img,
  HeroRightContainer,
  HeroInnerContainer,
  TextLoop,
  Title,
  Span,
  SubTitle,
  ResumeButton,
} from "./HeroStyle";
import HeroImg from "../../images/HeroImage.jpg";
import Typewriter from "typewriter-effect";
import { Bio } from "../../data/constants";
import Kabir from "../../data/Diptajit-Das-Resume.pdf";
const HeroSection = () => {
  const kabir = `https://drive.google.com/file/d/1SOBsJOV6feDl1vkwltViJpymVKWOrtAF/view?usp=sharing`;

  const handleResume = () => {
    window.open(kabir, "_blank");
  };
  return (
    <div>
      <HeroContainer>
        <HeroBg>
          <HeroBgAnimation />
        </HeroBg>
        <HeroInnerContainer id="home">
          <HeroLeftContainer id="Left">
            <Title id="user-detail-name">
              Hi, I am <br /> {Bio.name}
            </Title>
            <TextLoop>
              I am a
              <Span>
                <Typewriter
                  options={{
                    strings: Bio.roles,
                    autoStart: true,
                    loop: true,
                  }}
                />
              </Span>
            </TextLoop>
            <SubTitle id="user-detail-intro">{Bio.description}</SubTitle>
            <ResumeButton
              href={Bio.resume}
              target="display"
              id="resume-button-2"
              download={"Diptajit-Das-Resume.pdf"}
              onClick={handleResume}
            >
              Check Resume
            </ResumeButton>
          </HeroLeftContainer>
          <HeroRightContainer id="Right">
            <Img className="home-img" src={HeroImg} alt="hero-image" />
          </HeroRightContainer>
        </HeroInnerContainer>
      </HeroContainer>
    </div>
  );
};

export default HeroSection;
